import { useState } from 'react'
import styled from '@emotion/styled'
import { Theme } from '../../styles/settings/theme'
import { MediaQueries as Mq } from '../../styles/settings/theme'
import { Flex } from '../atoms/Basics'
import Lines from '../molecules/Lines'
import Pies from '../molecules/Pies'
import {
  Acoustics,
  Biologgers,
  Camera,
  DataMgmt,
  Drones,
  EDna,
  GIS,
  ML,
  Mobile,
  PAMgmt,
  Sensors
} from '../atoms/Icons'

const StyledCard = styled.div`
  height: ${(props) => (props.row === props.selectedRow ? '54rem' : '6.75rem')};
  border-radius: 4px;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  padding: 1.25rem;
  border: ${(props) =>
    props.hovered ? `2px solid ${props.theme.colors.orange}` : 'none'};
`

const CardContent = styled.div`
  display: ${(props) => (props.open ? 'block' : 'none')};
`
const TitleBar = styled(Flex)`
  height: 5rem;
`
const Title = styled.div`
  font-family: ${(props) => props.theme.fonts.title};
  font-size: ${(props) => props.theme.fontSizes[6]};
  font-weight: 300;
  color: ${(props) =>
    props.hovered ? props.theme.colors.orange : props.theme.colors.gray};
  margin: 0.9rem 0 0.5rem 0;
  line-height: 1.2;
  ${Mq.xl} {
    font-size: ${(props) => props.theme.fontSizes[5]};
    margin: 1.2rem 0 0.5rem 0;
  }
`
const SvgBox = styled.div`
  padding-top: ${(props) =>
    props.title === 'Biologgers' || props.title === 'eDNA/genomics'
      ? '.5rem'
      : 0};
`
const Card = ({
  title,
  sData,
  wData,
  pieData,
  i,
  handleSelectedRow,
  selectedRow,
  row,
  scaleTo
}) => {
  const [hover, setHover] = useState(false)

  const SVG_LOOKUP = {
    Acoustics: (
      <Acoustics
        w={'70px'}
        color={hover === i ? Theme.colors.orange : Theme.colors.gray}
      />
    ),
    Biologgers: (
      <Biologgers
        w={'85px'}
        color={hover === i ? Theme.colors.orange : Theme.colors.gray}
      />
    ),
    'Camera traps': (
      <Camera
        w={'55px'}
        color={hover === i ? Theme.colors.orange : Theme.colors.gray}
      />
    ),
    'Data mgmt tools': (
      <DataMgmt
        w={'62px'}
        color={hover === i ? Theme.colors.orange : Theme.colors.gray}
      />
    ),
    'UAVs/drones': (
      <Drones
        w={'74px'}
        color={hover === i ? Theme.colors.orange : Theme.colors.gray}
      />
    ),
    'eDNA/genomics': (
      <EDna
        w={'75px'}
        color={hover === i ? Theme.colors.orange : Theme.colors.gray}
      />
    ),
    'GIS/remote sensing': (
      <GIS
        w={'75px'}
        color={hover === i ? Theme.colors.orange : Theme.colors.gray}
      />
    ),
    'ML/computer vision': (
      <ML
        w={'60px'}
        color={hover === i ? Theme.colors.orange : Theme.colors.gray}
      />
    ),
    'Mobile apps': (
      <Mobile
        w={'42px'}
        color={hover === i ? Theme.colors.orange : Theme.colors.gray}
      />
    ),
    'PA mgmt tools': (
      <PAMgmt
        w={'70px'}
        color={hover === i ? Theme.colors.orange : Theme.colors.gray}
      />
    ),
    'Networked sensors': (
      <Sensors
        w={'55px'}
        color={hover === i ? Theme.colors.orange : Theme.colors.gray}
      />
    )
  }

  return (
    <StyledCard
      onClick={() => handleSelectedRow(i)}
      onMouseEnter={() => setHover(i)}
      onMouseLeave={() => setHover(null)}
      hovered={hover === i}
      row={row}
      selectedRow={selectedRow}
    >
      <TitleBar justifyContent="space-between">
        <Title hovered={hover === i}>{title}</Title>
        <SvgBox title={title}>{SVG_LOOKUP[title]}</SvgBox>
      </TitleBar>
      <CardContent open={row === selectedRow}>
        <Pies data={pieData} />
        <Lines
          type={'strengths'}
          data={sData}
          scale={scaleTo}
          category={title}
        />
        <Lines type={'weaknesses'} data={wData} scale={scaleTo} />
      </CardContent>
    </StyledCard>
  )
}

export default Card
